export default class LinkFormatterSimple implements ILinkFormatter {
	static create = (settings: ILinkFormatterConfig = null, gantt: any): LinkFormatterSimple => {
		return new LinkFormatterSimple(gantt);
	};
	protected _linkReg: RegExp;
	protected _gantt: any;

	constructor(gantt: any) {
		this._linkReg = /^[0-9\.]+/;
		this._gantt = gantt;
	}

	format = (link: ILink) : string => {
		const wbs = this._getWBSCode(link.source);
		return wbs;
	};

	canParse = (value: string) : boolean => {
		return this._linkReg.test(value);
	};
	parse = (value: string) : ILink => {
		if(!this.canParse(value)){
			return null;
		}

		const linkPart = this._linkReg.exec(value)[0].trim();

		const source = this._findSource(linkPart) || null;

		return {
			id: undefined,
			source,
			target: null,
			type: this._gantt.config.links.finish_to_start,
			lag: 0
		};
	};

	protected _getWBSCode = (source: number | string) => {
		const pred = this._gantt.getTask(source);
		if(this._gantt.getWBSCode){
			return this._gantt.getWBSCode(pred);
		}
		// the wbs plugin is not bundled in every edition - fall back to the task id
		return String(pred.id);
	};

	protected _findSource = (value: string) => {
		const reqTemplate = new RegExp("^[0-9\.]+", "i");
		if(reqTemplate.exec(value)){
			const wbs = reqTemplate.exec(value)[0];
			if(this._gantt.getTaskByWBSCode){
				const task = this._gantt.getTaskByWBSCode(wbs);
				if(task){
					return task.id;
				}
			}else if(this._gantt.isTaskExists(wbs)){
				// the wbs plugin is not bundled in every edition - fall back to the task id
				return wbs;
			}
		}
		return null;
	};
}